import Vue from "vue";
import Router from "vue-router";
const VueAnime = require("vue-animejs");

//
// ─── COMPONENT ──────────────────────────────────────────────────────────────────
//

const Header = () => import("@components/Header.vue");
const Body = () => import("@components/Body.vue");
const Footer = () => import("@components/Footer.vue");

//
// ─── VIEW ───────────────────────────────────────────────────────────────────────
//

const Home = () => import("@views/Home/Home.vue");
const About = () => import("@views/About/About.vue");
const Product = () => import("@views/Product/Product.vue");
const Contact = () => import("@views/Contact/Contact.vue");
const Available = () => import("@views/Available/Available.vue");
const Privacy = () => import("@views/Privacy/Privacy.vue");

//
// ─── ROUTE ─────────────────────────────────────────────────────────────────────
//

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      components: {
        header: Header,
        body: Body,
        footer: Footer
      },
      children: [
        {
          path: "home",
          alias: "",
          component: Home,
          name: "Home"
        },
        {
          path: "about",
          component: About,
          name: "About"
        },
        {
          path: "product",
          component: Product,
          name: "Product"
        },
        {
          path: "contact",
          component: Contact,
          name: "Contact"
        },
        {
          path: "available",
          component: Available,
          name: "Available"
        },
        {
          path: "privacy",
          component: Privacy,
          name: "Privacy"
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          x: 0,
          y: 0
        });
      }, 300);
    });
  }
});

//
// ─── EXPORT ─────────────────────────────────────────────────────────────────────
//
export default router;
